<div class="app-wrapper" [class.app-wrapper--rewind-intro]="rewindIntroActive()">
  <!-- Hide chrome during rewind intro to prevent flash -->
  @if (!rewindIntroActive()) {
    <!-- Purple gradient background -->
    <div class="app-gradient-bg">
      <div class="app-gradient-bg__light-orb"></div>
    </div>

    <!-- Static orbit background decoration (visible on all pages) -->
    <div class="app-orbit-bg">
      <div class="app-orbit app-orbit--1">
        <span class="app-orbit-dot app-orbit-dot--1"></span>
        <span class="app-orbit-dot app-orbit-dot--2"></span>
        <span class="app-orbit-dot app-orbit-dot--3"></span>
      </div>
      <div class="app-orbit app-orbit--2">
        <span class="app-orbit-dot app-orbit-dot--1"></span>
        <span class="app-orbit-dot app-orbit-dot--2"></span>
      </div>
      <div class="app-orbit app-orbit--3">
        <span class="app-orbit-dot app-orbit-dot--1"></span>
        <span class="app-orbit-dot app-orbit-dot--2"></span>
        <span class="app-orbit-dot app-orbit-dot--3"></span>
      </div>
    </div>
  }

  <div class="app-container">
    @if (!rewindIntroActive()) {
      <pu-header
        [mode]="headerMode()"
        [article]="stateService.currentArticle()"
        [activeMainTab]="stateService.activeMainTab()"
        [activeProductTab]="stateService.activeProductTab()"
        [stickyState]="stickyState()"
        (mainTabChange)="onMainTabChange($event)"
        (productTabChange)="onProductTabChange($event)"
        (languageChange)="onLanguageChange($event)"
      />
    }
    <div class="app-content">
      <router-outlet />
    </div>
    @if (!rewindIntroActive()) {
      <pu-footer />
    }
  </div>
</div>
